import { useQuery } from 'react-query';
import { fetchAllPeople } from '../network/employees';

export type PersonOption = { id: string; name: string; email: string | null };

/** Everyone in the caller's company, as `{ id, name, email }` for pickers. */
export function usePeopleOptions(enabled = true) {
  const query = useQuery(
    ['people-options'],
    async (): Promise<PersonOption[]> => {
      const { data } = await fetchAllPeople<any>();
      return data
        .filter((person) => person?.id)
        .map((person) => ({
          id: String(person.id),
          name:
            person.full_name ||
            [person.first_name, person.last_name].filter(Boolean).join(' ') ||
            person.email ||
            String(person.id),
          email: person.email ?? null,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    { enabled, staleTime: 5 * 60 * 1000 },
  );
  return { ...query, people: query.data ?? [] };
}
